/**
 * Shared types for list endpoints. Every paginated list returns the same
 * envelope per docs/API-CONTRACT.md.
 */

export interface Paginated<T> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
  page: number;
  pages: number;
}

export interface ListQuery {
  page?: number;
  page_size?: number;
  search?: string;
  ordering?: string;
}

export type QueryParamValue = string | number | boolean | undefined | null;

export function toQueryString(
  params: Record<string, QueryParamValue> | object,
): string {
  const out = new URLSearchParams();
  for (const [k, raw] of Object.entries(params)) {
    const v = raw as QueryParamValue;
    if (v === undefined || v === null || v === "") continue;
    out.set(k, String(v));
  }
  const s = out.toString();
  return s ? `?${s}` : "";
}
